<template>
 
   <div  >



<div v-if='addbox'   style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-md-flex d-none justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='closeaddbox'></div>





   <div style="width:455px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="font-size: 18px;font-weight:700;color: #0B0A23;">Add Address</p>
                <i class='bx bx-x' style="color:#0B0A23;font-size:25px;cursor:pointer!important" v-on:click='closeaddbox'></i>
              </div>


              <div class="pt-2"> 

                  <div style="width:100%;padding-right:0px">
                  
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter name" style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300" v-model='addrnames' name="">
                    </div>
                    
                  </div>
                   <div style="width:100%;padding-left:0px">
                    
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter mobile number" style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300"  v-model='addrmobile' name="">
                    </div>
                  </div>
    

                 
                  
                  <div style="width:100%;padding-right:0px">
                   
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" v-model='addrpincode' placeholder="Enter pincode" style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300" name="">
                    </div>
                    
                  </div>
                   <div style="width:100%;padding-left:0px">
                    
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter city" v-model='addrcity' style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300" name="">
                    </div>
                  </div>
               
                  
                   <div style="width:100%;padding-left:0px">
                     
                    <div style="" class="inpbor">
                      <textarea required=""  type="text" class="form-control placeaddr" placeholder="Enter Address" v-model='addraddress' style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300;min-height:80px" name=""></textarea>
                    </div>
                  </div>
              
              </div>



 

                   

 
                              <div class="mt-4 ">

                                <button v-if='!edit'   class="btn loggrn" style=" background: #EB3838;border-radius: 5px;cursor:pointer;font-weight: bold;
font-size: 16px;
font-weight:700;
padding:10px;
width:100%;
text-align: center;

color: #FFFFFF;
 "   >Add Address</button>
                                   <button v-else class="btn loggrn" style=" background: #EB3838;border-radius: 5px;cursor:pointer;font-weight: bold;
font-size: 16px;
font-weight:700;
padding:10px;
width:100%;
text-align: center;

color: #FFFFFF;
 "  >Edit Address</button>
                              
                               
                              </div>
                              

            </form>
          
        </div>
    
  </div>



</div>












<div v-if='addbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-md-none d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='closeaddbox'></div>
  <div style="width:670px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Add new address</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='closeaddbox'></i>
              </div>


              <div class="pt-2">
                
                
                  
   
                   




                    <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addrnames"  name="addrnames" class="logininput loginin"   required="" v-model='addrnames' minlength="10" maxlength="10">

                              <label style=" " for='addrnames' v-bind:class="{labelanims:true,defaultlabelanims:addrnames.length>0}" >Name</label>
                              <div class="bottomlines"></div>
                           
                     </div>
                      <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="number" id="addrmobile"  name="addrmobile" class="logininput loginin"   required="" v-model='addrmobile' minlength="10" maxlength="10">

                              <label style=" " for='addrmobile' v-bind:class="{labelanims:true,defaultlabelanims:addrmobile.length>0}" >Mobile Number</label>
                              <div class="bottomlines"></div>
                           
                     </div>
                      <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addrpincode"  name="addrpincode" class="logininput loginin"   required="" v-model='addrpincode' minlength="10" maxlength="10">

                              <label style=" " for='addrpincode' v-bind:class="{labelanims:true,defaultlabelanims:addrpincode.length>0}" >Pincode</label>
                              <div class="bottomlines"></div>
                           
                     </div>

 <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addrcity"  name="addrcity" class="logininput loginin"   required="" v-model='addrcity' minlength="10" maxlength="10">

                              <label style=" " for='addrcity' v-bind:class="{labelanims:true,defaultlabelanims:addrcity.length>0}" >City</label>
                              <div class="bottomlines"></div>
                           
                     </div>

 <div style=" position:relative;padding:0px!important" class="labhead"  >
                                
                         
                             <input  autofocus=""  type="text" id="addraddress"  name="addraddress" class="logininput loginin"   required="" v-model='addraddress' minlength="10" maxlength="10">

                              <label style=" " for='addraddress' v-bind:class="{labelanims:true,defaultlabelanims:addraddress.length>0}" >Address</label>
                              <div class="bottomlines"></div>
                           
                     </div>





 
              </div>



 

                   

 
                              <div class="d-flex align-items-center justify-content-center">

                                <button v-if='!edit'   class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Add Address</button>
                                   <button v-else class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Edit Address</button>
                              
                               
                              </div>
                              

            </form>
          
        </div>
    
  </div>


</div>


















<div v-if='deletebox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='deletebox=false'></div>
  <div style="width:360px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Delete this address?</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='deletebox=false'></i>
              </div>


                              <div class="d-flex align-items-center justify-content-center">

                                <button v-on:click='finaldelete'    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#E63631;padding:9px 25px;margin-top:30px;font-size:15px;cursor:pointer "  >Delete</button>
                                 
                              </div>
                              


             



 

                   

  

         
          
        </div>
    
  </div>


</div>











 
<div v-if='loginbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='loginbox=false'></div>
  <div v-if="logintype=='send'" style="width:470px;position:relative;z-index:100000000">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='login'>
              <div class="d-flex align-items-center justify-content-between mt-md-0 mt-3">
                <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">Enter Mobile Number</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>
              </div>


                            <div style="position: relative;    background: #FFFFFF!important;
    border: 1px solid #E7E5F2!important;
    border-radius: 5px;!important" class='labhead  d-flex align-items-center '  id="hideinputl">
                              <p style="padding-left:10px;color:rgb(11, 10, 35);font-weight:600" class="p91">+91 </p><span style="height:50px;width:1px;background:rgb(231 229 242 / 60%);margin:0px 15px;"></span>
                              
                              <div style="flex:1" class="d-md-block d-none">
                                
                        
                            <input autofocus=""  type="text" placeholder="Enter your mobile number" name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
                           
                                  </div>


                                     

                                      <div style="flex:1;position:relative" class="d-md-none d-block">
                                
                         
                             <input  autofocus=""  type="number" id="phonenumber" placeholder="Enter your mobile number"  name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
 
                    
                           
                                  </div>




                        





                          </div>
                              <div id="recaptcha-container"></div>

                   

 
                              <div class="d-flex align-items-center justify-content-center martp" style="" >

                                <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer " v-if='phone.length==10'  >Send Otp</button>
                                <button disabled=""  class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer "   v-if='phone.length!=10' >Send Otp</button>
                              </div>
                              

            </form>
          
        </div>
    
  </div>











  <div v-if="logintype=='otp'" style="width:500px;position:relative;z-index:100000000">
        
        <div  class="loginwrapper">

            

              <div class="d-flex align-items-center justify-content-between  mar40"  >

                 <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">OTP Verification</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>



               
              </div>

                      
       

            <div  class="otpboxes  " style="">
    <v-otp-input
      inputClasses="otp-input"
      :numInputs="6"
       separator=""
      :shouldAutoFocus="true"
      @on-complete="subotp"
       
    />
  </div>
                           

                   
 
                              

       
          
        </div>
    
  </div>




</div>

 





  <div  >
 
<div     style="" class="heads"> 






 

<!-- heaaderr -->

 


 




<div style="z-index: 10000;position: fixed;bottom: 0;left: 0;right: 0;padding:10px 27px;background: #fff;box-shadow:rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px" class="d-md-none d-flex align-items-center justify-content-between">


  






  <div
 
v-bind:class="[{ botactive: $route.path.toLowerCase()=='/'+info.name.toLowerCase()},{ botnotactive: $route.path.toLowerCase()!='/'+info.name.toLowerCase() },{navclass:true}]"  >


    <router-link to='/' style='text-decoration:none'>

 <img src="./images/files/homeblack.svg" style="transform:translateY(-1px)" >



</router-link>
</div>


 
 





   <div  class="botnotactive navclass"   style="position:relative">
    <router-link to="/bag" style='text-decoration:none'>

<div style="width:16px;height:16px;background:#EB3838;border-radius:50%; z-index:10000;   position: absolute;
    top: 3px;
    right: 4px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:10px;font-weight:700">{{rendercartlength}}</span>
</div>
 <img src="./images/files/bagbottom.svg"  style="width:20px;transform:translateY(-1px)" >

  </router-link>
  </div>




   <div   class="botactive navclass"   v-on:click='account'>
        

 <img src="./images/files/userwhite.svg" style="width:20px;transform:translateY(-1px)"   >
 
  </div>
   
</div>









<div  class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper" style="position:sticky;top:0px;background:#fff;z-index:10000000">
  <div class="container pad ">

  <div class="headerui     ">
  
  <router-link to='/' style='text-decoration:none' >
<div class="d-flex align-items-center mr-4  logowrapper">
  
  <img src="./images/finallogo.png" style="" class="logohigh">
</div>
</router-link>


<div style="position:fixed;top:0;left:0;right:0;bottom:0px;background:rgba(0,0,0,0.3);z-index:100000000;cursor:pointer"  class="d-md-block d-none" v-if='opacitybox'  v-on:click='opacitybox=false' ></div>




<svg  class="d-md-none d-block" style="width:20px;order:2" width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="1.5" y1="1.5" x2="20.5" y2="1.5" stroke="#0B0A23" stroke-width="3" stroke-linecap="round"/>
<line x1="1.5" y1="8.5" x2="14.5" y2="8.5" stroke="#0B0A23" stroke-width="3" stroke-linecap="round"/>
<line x1="1.5" y1="15.5" x2="20.5" y2="15.5" stroke="#0B0A23" stroke-width="3" stroke-linecap="round"/>
</svg>




<div class="inputboxui    d-md-flex d-none " style="z-index:1000000000" v-on:click='opacitybox=true'>

    <div v-if='searching' style="position:absolute;left;bottom:0px;height:2px;width:60px;background:#216EB4;   animation: animatename 3s linear infinite;"></div>

  <i class='bx bx-search searchsize'   style="color:#cfcfd4!important" ></i>
  <div class="actualinputbox">





 <vue-autosuggest
        v-model="query"
        :suggestions="filteredOptions"
        
        
        @input="onInputChange"
        @selected="onSelected"
        :get-suggestion-value="getSuggestionValue"
        :input-props="{id:'autosuggest__input', placeholder:'Search',class:'form-control searchinput'}">


        <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
            <i class='bx bx-search searchsize '   style="color:#B3B3B3!important;margin-right:10px;display:none" ></i>
            <div style="width:35px;border-radius:4px;margin-right:10px;overflow:hidden">
              <img :src='suggestion.item.imageurl' class="img-fluid" />
            </div>

          <div style="{ display: 'flex', color: '#1a181e'}">{{suggestion.item.name}} </div>


        </div>
      </vue-autosuggest>


     
  </div>

<label for='autosuggest__input' style="margin:0px;padding:0px;line-height: 0px!important;">
  

    <i v-if='query.length>0' v-on:click="removequery" style="cursor:pointer"  class='bx bx-x searchsize' ></i>
</label>
  
</div>



<!--mobile -->

 







<div class="d-flex align-items-center  navwrapper  ml-3   ">
  

  <div class="d-none align-items-center contactwhatsapp" style="">
    
    <img src="https://cdn.usbrandcolors.com/images/logos/whatsapp-logo.svg" style="width:20px;margin-right:6px;min-width:20px;">

 <p style="font-weight:600;color:#fff;font-size:13px">WhatsApp</p>

  </div>
 
  <router-link    to="/bag"  style='text-decoration:none'>
  <div class="d-flex align-items-center navitem pl-4 ml-4" style="position:relative">
    
          <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>


    <div style="width:16px;height:16px;background:#EB3838;border-radius:50%;    position: absolute;
    top: 2px;
    right: 10px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:11px;font-weight:600">{{rendercartlength}}</span>
</div>



 <svg width="17" height="20" viewBox="0 0 17 20" fill="#0B0A23" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.7" d="M15 5.83333H11.6667V3.33333C11.6667 1.4925 10.1742 0 8.33333 0C6.4925 0 5 1.4925 5 3.33333V5.83333H1.66667L0 20H16.6667L15 5.83333ZM5.83333 3.33333C5.83333 1.955 6.955 0.833333 8.33333 0.833333C9.71167 0.833333 10.8333 1.955 10.8333 3.33333V5.83333H5.83333V3.33333ZM5 7.5V8.75C5 8.98 5.18667 9.16667 5.41667 9.16667C5.64667 9.16667 5.83333 8.98 5.83333 8.75V7.5H10.8333V8.75C10.8333 8.98 11.02 9.16667 11.25 9.16667C11.48 9.16667 11.6667 8.98 11.6667 8.75V7.5H13.5183L13.9108 10.8333H2.75667L3.14917 7.5H5Z" fill="#0B0A23"/>
</svg>

 


  </div>
</router-link>  <div class="d-flex align-items-center    " style="position:relative;padding-left:50px"  >
      
      <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>

      <p class="mya" style="color: #0B0A23;

opacity: 0.8;font-weight: 500;
font-size: 14px;" v-on:click='account'>My Account</p>

<div v-if='user' style="position:absolute;top:0px;left:50%;transform:translateX(-50%);padding-top:40px;cursor:pointer" class="opanav">


  <div style="width:170px;background:#fff;border-radius:4px;box-shadow:0 0 10px rgba(0,0,0,0.1)">

    <router-link to='/whishlist' style='text-decoration:none'>
    <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Wishlist</p>
  </router-link>
   <router-link to='/account' style='text-decoration:none'>
       <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Account</p>
     </router-link>
          <p class="navhover"   v-on:click='logout' style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Logout</p>
  </div>
</div>


  </div>



</div>

</div>

  </div>
  
</div>








<!--- header -->



<div v-if='filterbox' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000000000" class="d-flex  filterbox">
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:100000" v-on:click='filterbox=false'></div>
  <div style="box-shadow:none!important;padding-bottom:18px" class="actfilterbox">


     <div class="d-flex align-items-center justify-content-between  " style="margin-bottom:25px">
                <p style="font-size: 23px;
font-weight:700;


color: #0B0A23;">Filter</p>
                <i class='bx bx-x' style="color:#0B0A23;font-size:28px;cursor:pointer" v-on:click='filterbox=false'  ></i>
              </div>

    <template v-for='itm in filters'>
      <div v-if='itm.selected' class="d-flex align-items-center" style="cursor:pointer;margin-top:15px" v-on:click='filterorder(itm)'>
        <div style="width:22px;height:22px;position:relative;border-radius:50px;border:1px solid rgba(246, 74, 84, 0.9)">
          <div style="position:absolute;top:4px;right:4px;bottom:4px;left:4px;border-radius:50px;background:rgba(246, 74, 84, 0.9);opacity:0.9"  ></div>
        </div>
        <p style="margin-left:15px;color:#0B0A23;font-weight:600;font-size:16px">{{itm.name}}</p>
      </div>
       <div v-else class="d-flex align-items-center" style="cursor:pointer;margin-top:15px" v-on:click='filterorder(itm)'>
        <div style="width:22px;height:22px;position:relative;border-radius:50px;border:1px solid rgba(166, 166, 192, 0.6)">
          <div style="position:absolute;top:4px;right:4px;bottom:4px;left:4px;border-radius:50px;background:rgba(255,255,255,0.5);opacity:0.9"  ></div>
        </div>
        <p style="margin-left:15px;color:#0B0A23;font-weight:500;font-size:16px">{{itm.name}}</p>
      </div>
    </template>
    
  </div>
</div>

<!-- filters -->
 


 

<div  v-if='loadstatus && theme==3' >

</div>


<div  v-else-if='loadstatus && theme==2' >






 

</div>



<div v-else-if='loadstatus && theme==1' >



 

<div class="pt-md-4 pb-md-5 pt-4 pb-3  headerwrapper2    "  style="background:#fff!important">
  <div class="container  pads" style="padding:0px">
  <div class="   ">



<div class=" d-flex  justify-content-between  align-items-center  mt-md-5 mb-md-4 mb-3 mt-md-3 mt-0 ">
  

<p style="margin-top:0px!important"    class="shopbag">Account</p>




        <p  class="mobiletext">{{mobilenum}}</p>

</div>

 <div style="    height: 1px;
    background: rgba(217, 215, 234, 0.3);" class="mt-4 d-md-none d-block"></div>



<div class="d-md-none d-block" style="height:calc(100vh - 60px);background:#fff;padding:10px 0px;padding-top:33px!important">
  

  <router-link  to="/addresses" style='text-decoration:none!important'>

    <div     style="cursor:pointer "     class="d-flex align-items-center  pb-3"  >
             

                         <p style="font-weight: 700;font-size: 15px;color: #000000;opacity: 0.8;">My Address</p>

           
            
          </div>
</router-link>




  <router-link  to='/whishlist' style='text-decoration:none!important'>

    <div     style="cursor:pointer "     class="d-flex align-items-center  py-3"  >
             

                         <p style="font-weight: 700;font-size: 15px;color: #000000;opacity: 0.8;">My Wishlist</p>

           
            
          </div>
</router-link>

  <router-link  to='/orders' style='text-decoration:none!important'>


    <div     style="cursor:pointer "     class="d-flex align-items-center  py-3"  >
          
            <p style="font-weight: 700;font-size: 15px;color: #000000;opacity: 0.8;">My Orders</p>
            
            
          </div>

</router-link>



    <div     style="cursor:pointer; "   v-on:click='signout'   class="d-flex align-items-center  py-3"  >
                                         <p style="font-weight: 700;font-size: 15px;color: #000000;opacity: 0.8;">Sign out</p>

             
            
          </div>

</div>






<div style=" height:75vh" class="cartborder d-md-block d-none"   >
  
  <div class="container " style="padding:0px;margin:0px;height:100%">
    <div class="row" style="padding:0px;margin:0px;height:100%">
      <div class="col-md-3  mobcontainer" style="padding:0px;margin:0px;height:100%">
        <div style="height:100%;padding-top:0px ">
          <div  class="  paditemslen"> 
              <p style="font-weight: 600;
font-size: 18px;
line-height: 20px;
 


color: #0B0A23;

opacity: 0.8;">Account List
</p>

          </div>
          


          <div>
            

              <div       v-on:click="tab='myorders'"          v-if="tab=='myorders'" class="d-flex align-items-center px-4 py-4" style=" cursor: pointer;background: rgb(255 228 230 / 30%);border-right: 0px solid #EB3838;color: rgb(20, 110, 180);">
         

            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.0817 8.88167L20 10L9.99833 15.8333L0 10L1.9175 8.88167L9.99833 13.5967L18.0817 8.88167ZM9.99833 17.7625L1.9175 13.0475L0 14.1667L9.99833 20L20 14.1667L18.0817 13.0483L9.99833 17.7625ZM9.99833 1.92917L16.6917 5.83333L9.99833 9.7375L3.3075 5.83333L9.99833 1.92917ZM9.99833 0L0 5.83333L9.99833 11.6667L20 5.83333L9.99833 0V0Z" fill="#0B0A23"/>
</svg>


            <p style="margin-left:15px;font-size:16px;font-weight:500;margin-bottom:0px;font-size: 16px;
 


color: #0B0A23;">My Orders</p>
            
          </div>

              <div    v-on:click="tab='myorders'"     style="cursor:pointer;"    v-else class="d-flex align-items-center px-4 py-4"  >
                   <svg  style='opacity:0.6' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.0817 8.88167L20 10L9.99833 15.8333L0 10L1.9175 8.88167L9.99833 13.5967L18.0817 8.88167ZM9.99833 17.7625L1.9175 13.0475L0 14.1667L9.99833 20L20 14.1667L18.0817 13.0483L9.99833 17.7625ZM9.99833 1.92917L16.6917 5.83333L9.99833 9.7375L3.3075 5.83333L9.99833 1.92917ZM9.99833 0L0 5.83333L9.99833 11.6667L20 5.83333L9.99833 0V0Z" fill="#0B0A23"/>
</svg>

            <p style="margin-left:15px;font-size:16px;font-weight:500;margin-bottom:0px;color:#646378">My Orders</p>
            
          </div>

          </div>
        




          <div>
              <div   v-on:click="tab='address'" v-if="tab=='address'" class="d-flex align-items-center px-4 py-4 "  style=" cursor: pointer;background: rgb(255 228 230 / 30%);border-right: 0px solid #EB3838;color: rgb(20, 110, 180);" >
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5 2.625C12.3646 2.625 14 4.13875 14 5.86425C14 7.658 12.5002 10.1876 10.5 13.3551C8.49975 10.1876 7 7.658 7 5.86425C7 4.13875 8.63538 2.625 10.5 2.625ZM10.5 0.875C7.7455 0.875 5.25 3.10888 5.25 5.86425C5.25 8.61875 7.52675 11.9079 10.5 16.625C13.4733 11.9079 15.75 8.61875 15.75 5.86425C15.75 3.10888 13.2554 0.875 10.5 0.875ZM10.5 7.875C9.53312 7.875 8.75 7.09188 8.75 6.125C8.75 5.15812 9.53312 4.375 10.5 4.375C11.4669 4.375 12.25 5.15812 12.25 6.125C12.25 7.09188 11.4669 7.875 10.5 7.875ZM17.5 13.125H14.7569C14.42 13.6859 14.0586 14.2704 13.6789 14.875H16.4185L16.856 15.75H13.125L12.824 16.226L12.5711 16.625H13.0594L13.8101 18.375H7.25813L8.00887 16.625H8.428L8.17513 16.226L7.875 15.75H6.08825L5.20363 14.875H7.32112C6.9405 14.2704 6.57913 13.6859 6.24312 13.125H3.5L0 20.125H21L17.5 13.125ZM6.30525 18.375H2.8315L4.375 15.288L5.7015 16.625H7.05687L6.30525 18.375ZM14.0122 16.625H17.2935L18.1685 18.375H14.763L14.0122 16.625Z" fill="#0B0A23"/>
</svg>

            <p style="margin-left:15px;font-size:16px;font-weight:500;margin-bottom:0px;font-size: 16px;
 


color: #0B0A23;">My Address</p>


 
            
          </div>
              <div v-else v-on:click="tab='address'" class="d-flex align-items-center px-4 py-4  " style="cursor:pointer;" >
         <svg style='opacity:0.6' width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5 2.625C12.3646 2.625 14 4.13875 14 5.86425C14 7.658 12.5002 10.1876 10.5 13.3551C8.49975 10.1876 7 7.658 7 5.86425C7 4.13875 8.63538 2.625 10.5 2.625ZM10.5 0.875C7.7455 0.875 5.25 3.10888 5.25 5.86425C5.25 8.61875 7.52675 11.9079 10.5 16.625C13.4733 11.9079 15.75 8.61875 15.75 5.86425C15.75 3.10888 13.2554 0.875 10.5 0.875ZM10.5 7.875C9.53312 7.875 8.75 7.09188 8.75 6.125C8.75 5.15812 9.53312 4.375 10.5 4.375C11.4669 4.375 12.25 5.15812 12.25 6.125C12.25 7.09188 11.4669 7.875 10.5 7.875ZM17.5 13.125H14.7569C14.42 13.6859 14.0586 14.2704 13.6789 14.875H16.4185L16.856 15.75H13.125L12.824 16.226L12.5711 16.625H13.0594L13.8101 18.375H7.25813L8.00887 16.625H8.428L8.17513 16.226L7.875 15.75H6.08825L5.20363 14.875H7.32112C6.9405 14.2704 6.57913 13.6859 6.24312 13.125H3.5L0 20.125H21L17.5 13.125ZM6.30525 18.375H2.8315L4.375 15.288L5.7015 16.625H7.05687L6.30525 18.375ZM14.0122 16.625H17.2935L18.1685 18.375H14.763L14.0122 16.625Z" fill="#0B0A23"/>
</svg>


            <p style="margin-left:15px;font-size:16px;font-weight:500;margin-bottom:0px;color:#646378">My Address</p>
            
          </div>


          </div>
           
             <div class="d-flex align-items-center px-4 py-4  " v-on:click='signout' style="cursor: " >
           <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.6667 14.8334V14.7642C10.685 15.335 9.54833 15.6667 8.33333 15.6667C4.6575 15.6667 1.66667 12.6759 1.66667 9.00002C1.66667 5.32419 4.6575 2.33335 8.33333 2.33335C9.54833 2.33335 10.685 2.66502 11.6667 3.23585V1.36502C10.645 0.918354 9.52 0.666687 8.33333 0.666687C3.73167 0.666687 0 4.39752 0 9.00002C0 13.6025 3.73167 17.3334 8.33333 17.3334C9.52 17.3334 10.645 17.0817 11.6667 16.635V14.8334ZM15 6.84002L17.4692 9.00002L15 11.16V9.83335H8.33333V8.16669H15V6.84002ZM13.3333 3.16669V6.50002H6.66667V11.5H13.3333V14.8334L20 9.00002L13.3333 3.16669Z" fill="#0B0A23"/>
</svg>

            <p style="margin-left:15px;font-size:16px;font-weight:500;margin-bottom:0px;color:#4d4d4d">Log out</p>
            
          </div>
        </div>
      </div>
      <div class="col-md-9 mobcontainer" style="padding:0px;margin:0px;height:100%">


   
        <div style="height:100%;border-left:1px solid rgb(231 231 247 / 50%);padding:30px;overflow:scroll; " v-if="tab=='address'">
            
            <div  class="  paditemslen d-flex align-items-center justify-content-between" style=" position:sticky;top:0;background:#F9F9FB!important;margin:0px -30px;padding-top:20px!important;padding-bottom:20px!important;z-index:1000 ;margin-bottom:15px!important "> 
            <p  style="font-weight: 600;margin-left:10px;
font-size: 18px;
line-height: 20px;
 


color: #0B0A23;

opacity: 0.8;">Address</p>

            

          </div>



  <div class="container" style="padding:0px;margin:0px">
                <div class="row" style="padding:0px;margin:0px"  >


                  <template v-for='(itm,index) in address'>
                    
     
                  <div v-if='!(index % 2 == 0)' class="col-md-6 mt-3" style="padding:0px;margin:0px"  >

 
                    <div style="padding-left:10px;">

                      <div style="border: 1px solid rgba(231, 231, 247, 0.5);
    border-radius: 5px;
    padding: 20px;
    cursor: pointer;
    font-family: Montserrat, sans-serif;
 
    background: rgba(239, 239, 245, 0.45);"> 
                           
                            
                                     <p style="" class="addrname1">{{itm.name}}</p>

                            <p style=" " class="addrmobile1">Mobile:  {{itm.mobile}} </p>
                            <p style="" class="addraddr1">{{itm.address}}</p>
                            <p style="" class="addrcity1">{{itm.city}} . {{itm.pincode}}</p>



 <div class="d-flex align-items-center mt-md-3 mt-2">
                                <p style="" class="edit1" v-on:click='editaddress(itm)'>Edit</p>
                              <p style="
" class="del1" v-on:click='deleteaddress(itm)'>Delete</p>
                            </div>




 

                      </div>
                        
                    </div>
              
                  </div>

                  <div v-else class="col-md-6 mt-3" style="padding:0px;margin:0px"  >
                     <div style="padding-right:10px;">

                      <div style="border: 1px solid rgba(231, 231, 247, 0.5);
    border-radius: 5px;
    padding: 20px;
    cursor: pointer;
    font-family: Montserrat, sans-serif;
 
    background: rgba(239, 239, 245, 0.45);"> 
                       
                                     <p style="" class="addrname1">{{itm.name}}</p>

                            <p style=" " class="addrmobile1">Mobile:  {{itm.mobile}} </p>
                            <p style="" class="addraddr1">{{itm.address}}</p>
                            <p style="" class="addrcity1">{{itm.city}} . {{itm.pincode}}</p>



 <div class="d-flex align-items-center mt-md-3 mt-2">
                                <p style="" class="edit1" v-on:click='editaddress(itm)'>Edit</p>
                              <p style="
" class="del1" v-on:click='deleteaddress(itm)'>Delete</p>
                            </div>


                             
                          


                      </div>
                        
                    </div>
              
                  </div>

                               </template>




                      <div  v-if='!(address.length % 2 == 0)'     class="col-md-6 mt-3" style="padding:0px;margin:0px;"  >
                     <div style="padding-left:10px;height:100%">
  <div style="border:1px solid #EB3838;border-radius:5px;padding:13px;cursor:pointer;font-family: 'Montserrat', sans-serif;height:100%" class="d-flex align-items-center justify-content-center "  v-on:click='addbox=true'> 
                              
                            
                           
                            <div class="d-flex align-items-center justify-content-center " v>
                           
                             <p style="font-weight: 600;
font-size: 16px;
 

text-align: center;

color: #EB3838;" >Add Address</p>
                            </div>

                             
                          


                      </div>
                        
                    </div>
              
                  </div>



                         <div   v-else   class="col-md-6 mt-3" style="padding:0px;margin:0px;"  >
                     <div style="padding-right:10px;height:100%">

 <div style="border:1px solid #EB3838;border-radius:5px;padding:13px;cursor:pointer;font-family: 'Montserrat', sans-serif;height:100%" class="d-flex align-items-center justify-content-center "  v-on:click='addbox=true'> 
                              
                            
                           
                            <div class="d-flex align-items-center justify-content-center " v>
                           
                             <p style="font-weight: 600;
font-size: 16px;
 

text-align: center;

color: #EB3838;" >Add Address</p>
                            </div>

                             
                          


                      </div>
                        
 
                        
                    </div>
              
                  </div>


</div>
</div>
      </div>






        <div style="height:100%;border-left:1px solid rgb(231 231 247 / 50%);padding:30px;overflow:scroll;padding-top:0px" v-if="tab=='myorders'">

 

<div  class="  paditemslen d-flex align-items-center justify-content-between" style=" position:sticky;top:0;background:#F9F9FB!important;margin:0px -30px;padding-top:10px!important;padding-bottom:10px!important;z-index:1000 ;margin-bottom:5px!important "> 
            <p  style="font-weight: 600;margin-left:10px;
font-size: 18px;
line-height: 20px;
 


color: #0B0A23;

opacity: 0.8;">Showing All Orders</p>

              <div class="d-flex align-items-center" style="margin-right:10px;border:1px solid rgb(231 231 247 / 50%);padding:8px 16px;border-radius:4px;cursor:pointer;background:#fff" v-on:click='filterbox=true'>
                <i class='bx bx-filter' style="font-size:22px"></i>
                  <p style="margin-left:8px;font-weight: 600;
font-size: 14px;
 

text-transform: capitalize;
color: #0B0A23;">{{filtertext}}</p>

              </div>

          </div>





            <div class="container" style="padding:0px;margin:0px">
                <div class="row" style="padding:0px;margin:0px"  >


                  <template v-for='(itm,index) in orders'>
                    
     
                  <div  class="col-md-12 mt-4" style="padding:0px;margin:0px"  >

                      <router-link :to="'/orderdetails/'+itm.orderid" style='text-decoration:none'>

                            <div class="container-fluid" style="padding:30px 20px;margin:0px;border:1px solid rgb(231 231 247 / 50%);border-radius:7px;    background: rgb(249 249 251 / 60%) !important;">
                              <div class="row align-items-center" style="padding:0px;margin:0px">
                                <div class="col-md-2" style="padding:0px;margin:0px">
                                   <div class="d-flex align-items-center">
                              <div style="width:70px;overflow:hidden;border-radius:5px">
                                <img :src="itm.items[0].imageurl[0]" class="img-fluid" style="width:100%">
                              </div>
                                

                            </div>
                                </div>


                                  <div class="col-md-3  " style="padding:0px;margin:0px">
                                    <div  class="d-flex align-items-center ">
                                
                                 <div  v-if="itm.status=='pending'"  style="background:#F4B845;padding:6px 13px;border-radius:5px;">
                                   <p style="color:#fff;font-size:14px;font-weight:600;text-transform: capitalize;">{{itm.status}}</p>
                                 </div>
                                  <div  v-else-if="itm.status=='Accepted'"  style="background:#53B42D;padding:6px 13px;border-radius:5px;">
                                   <p style="color:#fff;font-size:14px;font-weight:600;text-transform: capitalize;">{{itm.status}}</p> 
                                 </div>
                                    <div  v-else-if="itm.status=='Shipped'"  style="background:#EE7438;padding:6px 13px;border-radius:5px;">
                                   <p style="color:#fff;font-size:14px;font-weight:600;text-transform: capitalize;">{{itm.status}}</p>
                                 </div>
                                  <div  v-else-if="itm.status=='Delivered'"  style="background:#3AD177;padding:6px 13px;border-radius:5px;">
                                   <p style="color:#fff;font-size:14px;font-weight:600;text-transform: capitalize;">{{itm.status}} </p>
                                 </div>
                                  <div  v-else-if="itm.status=='Cancelled'"  style="background:#F05151;padding:6px 13px;border-radius:5px;">
                                   <p style="color:#fff;font-size:14px;font-weight:600;text-transform: capitalize;">{{itm.status}}</p>
                                 </div>
                                   <div  v-else-if="itm.status=='Not Delivered'"  style="background:#F05151;padding:6px 13px;border-radius:5px;">
                                   <p style="color:#fff;font-size:14px;font-weight:600;text-transform: capitalize;">{{itm.status}}</p>
                                 </div>
                                   <div  v-else-if="itm.status=='Rejected'"  style="background:#F05151;padding:6px 13px;border-radius:5px;">
                                   <p style="color:#fff;font-size:14px;font-weight:600;text-transform: capitalize;">{{itm.status}}</p>
                                 </div>
                              </div>
                                </div>

                                   <div class="col-md-3" style="padding:0px;margin:0px">
                                         <div class="pl-4 ">
                                    <p class="actprice" style=" font-size: 16px;
 font-weight:500;


color: #0B0A23;">Order #{{itm.orderid}}</p>
                                    <p  class="actprice"  style=" font-size: 15px;
 
font-weight:500;

 

color: #0B0A23;

opacity: 0.6;margin-top:0px">{{renderdate(itm.date,itm.actmins)}}</p>
                            </div>
       
                                </div>


                                  <div class="col-md-4" style="padding:0px;margin:0px ">
                                   <div class=" " style="text-align:right">
                                  
                                    <p  class="actprice" style="font-weight: 500;font-size: 20px;text-align: right;color: #EB3838;">₹{{itm.total}}</p>
  <p class="actprice" style=" font-size: 14px;line-height: 20px;font-weight:500;text-align: right;color: #0B0A23;opacity: 0.6;">{{renderlengthitem(itm.items)}} Item</p>
                            </div>
                                </div>

                        


                             
                   
                     </div>
                            </div>
                  </router-link>
                  </div>

                 

                               </template>

 
                  
                </div>
            </div>





        </div>
      </div>
    </div>
  </div>
 
</div>





 



 
 </div>

  </div>
  
</div>
 

 
 
</div>
 


 

<div  v-else >



    <div  style="height:calc(100vh - 94px);background:#fff; " class="d-md-flex d-none align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>




    <div  style="height:calc(100vh - 54px);background:#fff; " class="d-md-none d-flex align-items-center justify-content-center">
   
   <div style="width:80px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>





 

      </div>





 


 





 


 














  



   
 
 
 

 <div style="background: #262626;" class="p-5 mt-5">
   
   <div class="container py-5">
     <div class="row justify-content-center">



      
       <div class="col-md-4"  >
         <div>
             
 


 <div style="margin-left:-8px">
       <img  src="./images/finallogo.png" class="img-fluid" style="position:relative;height:40px" >

 </div>
<p style="font-weight: 400;font-size: 15px;margin:15px 0px;color: #FFFFFF;line-height: 26px;font-weight:600;display:none">SAYRA APPARELS PVT LTD</p>
 
 <h2 style="color:#fff;font-weight:600;font-size:18px;margin-top:22px">Get in Touch</h2>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Monday - Saturday</p>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">9:00 AM to 6:00 PM</p>
<a href="tel:+918433408665" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">+91 8433408665</a>
<a href="mailto:support@sayra.in" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">support@sayra.in</a>
<div class="d-none align-items-center   mt-4">
  <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;margin-right:13px;min-width:30px;background:#fff;margin-left:0px">
      <i class='bx bxl-facebook' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-instagram' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-youtube' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-twitter' style="color:#1B1A31;font-size:20px"></i>
  </div>
</div>

         </div>
       </div>


       <div class="col-md-4 mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">Customer Help</h2>
           <div>
             <router-link  to='/termsconditions' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Terms & Condition</router-link>


              <router-link   to='/privacypolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Privacy Policy</router-link>
               <router-link   to='/refundpolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Refund Policy</router-link>
                <router-link  to='/shipping'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Shipping Policy</router-link>
              <router-link  to='/returnexchange'  style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Return & Exchange</router-link>

                       <router-link to="/about"    style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">About Us</router-link>
           </div>
         </div>
       </div>
      
       <div class="col-md-4  mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">My Account</h2>
           <div>
             <router-link to='/bag' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">View Cart</router-link>

              <a href="https://tracklite.in/c/sayraindia" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Track My Order</a>

               <router-link to='/contact' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Contact Us</router-link>
            </div>
         </div>
       </div>
           


           
         </div>




       </div>

     </div>

 <div style="background: #262626;" class=" d-none p-5 mt-5">
   
   <div class="container py-5">
     <div class="row justify-content-center">
       <div class="col-md-4"  >
         <div>
             
 
 <div style="margin-left:-8px">
       <img  src="./images/finallogo.png" class="img-fluid" style="position:relative;height:40px" >

 </div>
<p style="font-weight: 400;font-size: 15px;margin:15px 0px;color: #FFFFFF;line-height: 26px;font-weight:600;display:none">SAYRA APPARELS PVT LTD</p>
<h2 style="color:#fff;font-weight:600;font-size:18px">Customer Help</h2>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px">Monday - Saturday</p>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px">9:00 AM to 6:00 PM</p>
<a href="tel:+918433408665" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px">+91 8433408665</a>
<a href="mailto:support@sayra.in" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px">support@sayra.in</a>
<div class="d-none align-items-center   mt-4">
  <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;margin-right:13px;min-width:30px;background:#fff;margin-left:0px">
      <i class='bx bxl-facebook' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-instagram' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-youtube' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-twitter' style="color:#1B1A31;font-size:20px"></i>
  </div>
</div>

         </div>
       </div>


       <div class="col-md-4 mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">Customer Help</h2>
           <div>
  <a href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/Terms%20%26%20condition%20.pdf?alt=media&token=c99b4120-31e8-408c-8f53-10ff6aae2588" target="_blank" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Terms & Condition</a>
              <a  href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/PRIVACY%20POLICY.pdf?alt=media&token=3284ed97-a8d2-49a6-9a2c-a5ee8639319a" target="_blank"  style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Privacy Policy</a>
               <a  href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/REFUND%20POLICY.pdf?alt=media&token=297c57e9-ec32-4437-a64e-bba5f32d1f17" target="_blank"  style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Refund Policy</a>
                <a href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/SHIPPING%20POLICY.pdf?alt=media&token=31ead305-7abb-4248-95b0-65e1eb9c7a22" target="_blank"   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Shipping Policy</a>
                       <a href="https://firebasestorage.googleapis.com/v0/b/sayra-a4201.appspot.com/o/Return%26%20exchange.pdf?alt=media&token=bd2f66df-2fc9-4836-96d5-5a0e3b3b3d71" target="_blank"   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Return & Exchange</a>

                       <router-link to="/about"    style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">About Us</router-link>
           </div>
         </div>
       </div>
      
       <div class="col-md-4  mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">My Account</h2>
           <div>
             <router-link to='/bag' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">View Cart</router-link>

              <a href="https://tracklite.in/c/sayraindia" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Track My Order</a>
               <a href="mailto:support@sayra.in" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Help</a>
            </div>
         </div>
       </div>
           


           
         </div>




       </div>

     </div>
   
   


 
 
  </div>
</div>
</div>
</template>

<script>
 
  import firebase from 'firebase'


 const fb = require('./firebaseconfig.js')
 
export default {
         props: ['loadstatus','info','carts','uids','theme'],

  
  data () {

        return{


       query: "",
      selected: "",
      filteredOptions:[],
      mobilesearch:false,
      filtertext:'All orders',
      searching:false,
      opacitybox:false,
      suggestions: [
        {
          data: [
             
          ]
        }
      ], limit: 10,
  




            user:false,
            addrnames:'',
            addrmobile:'',
            mobilenum:'',
            addrpincode:'',
            addrcity:'',
            deletebox:false,
            addraddress:'',
            emptydata:false,
            tab:'myorders',
            addbox:false,
            orders:[],
            orderss:[],
            edit:false,
            docid:null,
            address:[],
            filterbox:false,
            filters:[
            {
              name:'All orders',
              selected:true
            },
            {
              name:'Active orders',
              selected:false,
            },
            {
              name:'Completed orders',
              selected:false,
            },
            {
              name:'Failed orders',
              selected:false,
            },
            ]


        }
     
    
  },
  created(){
 

      if(firebase.auth().currentUser){



this.mobilenum=firebase.auth().currentUser.phoneNumber


var vm=this

var address=[]

 fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').orderBy('date','desc').onSnapshot(querySnapshot=>{
 address=[]
    querySnapshot.forEach((doc)=> {
      
 
      address.push({id:doc.id,...doc.data()})
        
    })
 
 

vm.address=[
...address
]
})


var z=[]
     fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('orders').orderBy('date','desc').onSnapshot(querySnapshot=>{
 z=[]
    querySnapshot.forEach((doc)=> {
      
 
      z.push({id:doc.id,...doc.data()})
        
    })
 
 

 
    vm.orders=[

    ...z

    ]


    vm.orderss=[

    ...z

    ]

 

 vm.loadtest=true
 if(vm.orders.length>0){
vm.emptydata=false
 }else{
   vm.emptydata=true
 }

 
 


  })





  this.user=true
 }else{

    this.user=false
 }



   },
   computed:{
 rendercartlength(){

var cartlength=0
        var x=this.carts.forEach((itm)=>{

           cartlength=Number(itm.quantity)+cartlength
        })
        return cartlength

    },
   },
   methods:{

renderlengthitem(items){

var x=0
  items.forEach((itm)=>{

      x=x+itm.quantity
  })
  return x

} ,     
     clickHandler(item) {
 
    },
    onSelected(item) {
 

 

  this.selected = item.item;
 
  this.opacitybox=false
  this.$router.push({ path:  '/productsdetails/'+item.item.category+'/'+item.item.id })


   },
   removequery(){

      this.suggestions[0].data=[]

        this.filteredOptions = [{

         data:  []

        }];

this.searching=false
 
 this.query=''
   },
   async onInputChange(text) {

 
 

 

  this.suggestions[0]=[
  ]



        this.filteredOptions = [{
         data:   []
        }
        ];

 if(text.length>2){


 this.searching=true
const { docs } =   await fb.db.collection('adminportal').doc(this.uids).collection('products').where('searchableindex', 'array-contains',text.trim().toLowerCase()).limit(5).get()

   this.suggestions[0].data=[]

        this.filteredOptions = [{

         data:  []

        }];

 
 docs.map((doc) => {
 


 

  this.suggestions[0].data.push(doc.data());



        this.filteredOptions = [{
         data:   this.suggestions[0].data
        }
        ];



 });

 this.searching=false

      


 }
 

      
    },

    /**
     * This is what the <input/> value is set to when you are selecting a suggestion.
     */

    getSuggestionValue(suggestion) {
 

      return suggestion.item.name 
    },
    focusMe(e) {
      console.log(e) // FocusEvent
    },


async signout(){
  await firebase.auth().signOut()

  this.$router.push({ path: '/' })

},
    async finaldelete(){
         await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').doc(this.docid).delete()

         this.deletebox=false
    },
    deleteaddress(item){
 

        this.deletebox=true

        this.docid=item.id

 

 


    },
    editaddress(item){


var vm=this
         this.edit=true
        this.docid=item.id

 
  vm.addrnames=item.name
 
  vm.addrmobile=item.mobile
 vm.addrpincode=item.pincode
   vm.addrcity=item.city
 vm.addraddress=item.address

vm.addbox=true



    },
   async addaddress(){


var vm=this
    if(this.edit){
 
 


 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').doc(vm.docid).update({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })



 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false
   this.edit=false
        this.docid=null




         }else{




      var vm=this
 

 

 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').add({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })



 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false





    }
    },
    closeaddbox(){
      this.addbox=false

    },
    filterorder(item){

var text=''

var y=this.filters.map((itms)=>{

  if(item.name==itms.name){
    text=itms.name
    return {
      ...itms,
      selected:true
    }
  }else{
     return {
      ...itms,
      selected:false
    }
  }
})
     

if(item.name=='All orders'){


 var x=[
 ...this.orderss
 ]

}
else if(item.name=='Completed orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Delivered' 
 })
}
else if(item.name=='Active orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Accepted'|| itm.status=='pending' || itm.status=='Shipped'

 })
}
else{
 var x=this.orderss.filter((itm)=>{

          return itm.status=='Rejected'|| itm.status=='Cancelled' || itm.status=='Not Delivered'

 })

}
 
 
 
      this.orders=[
      ...x
      ]
      this.filters=[
      ...y
      ]
      this.filtertext=text

      this.filterbox=false

    },

  account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/account' })

 }else{
this.loginbox=true
 }
    },
    
     renderdate(timestamp,actmins){


      var date=timestamp.toDate();
      var stringdate=date.getDate()+'/'+date.getMonth()+'/'+date.getFullYear()

      var today=new Date()
      var stringtoday=today.getDate()+'/'+today.getMonth()+'/'+today.getFullYear()
      var yesterday=new Date()
      yesterday.setDate(yesterday.getDate() - 1);


      var stringyesterdayday=yesterday.getDate()+'/'+yesterday.getMonth()+'/'+yesterday.getFullYear()
 
 

if(actmins!=undefined){
if(stringdate==stringtoday){
 
 return 'Today '+actmins
 
}else if(stringyesterdayday==stringdate){

 
 return 'Yesterday ' +actmins

   
}else{

return stringdate +','+actmins

}
}else{

  if(stringdate==stringtoday){
 
 return 'Today '
 
}else if(stringyesterdayday==stringdate){

 
 return 'Yesterday ' 

   
}else{

return stringdate 

}
}


     

    },

  
      logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 
vm.user=false
vm.$router.push({ path: '/'  })

}).catch(function(error) {
 
});
      }
   }


   
    
 
  
}
</script>
<style scoped >
 

</style>
 



// WEBPACK FOOTER //
// src/account.vue